import RightStickerContainer from './RightStickerContainer.jsx';

export {
  RightStickerContainer
}


// WEBPACK FOOTER //
// ./components/partials/right-sticker/index.js